var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.mergeLoadedPolygons)?_c('OverwriteGeneralMapOption',{attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}}):_c('WarningMapOverwrite')
}
var staticRenderFns = []

export { render, staticRenderFns }